export default {
  'sidebar.compras': 'Compras',
};
